import * as Types from '../its-organizer-api.types.g';

import { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  LocalDate: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type ICandidate = {
  __typename?: 'Candidate';
  attempt: Scalars['Int'];
  closeTime?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']>;
  demoStatus: CandidateStatus;
  exam: IExam;
  grade?: Maybe<Scalars['String']>;
  grade_letter?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itembankDemoId: Scalars['String'];
  itembankId: Scalars['String'];
  metadata: Array<IMetaDataField>;
  module: IModule;
  moduleGroup?: Maybe<IModuleGroup>;
  name: Scalars['String'];
  objectives?: Maybe<Array<IObjective>>;
  passed?: Maybe<Scalars['Boolean']>;
  person: IPerson;
  progress?: Maybe<Scalars['String']>;
  reference: Scalars['String'];
  score?: Maybe<IScore>;
  sections?: Maybe<Array<ISection>>;
  startTime?: Maybe<Scalars['String']>;
  startable: Scalars['Boolean'];
  status: CandidateStatus;
  timePassed?: Maybe<Scalars['String']>;
};

export enum CandidateStatus {
  Completed = 'completed',
  Inprogress = 'inprogress',
  Open = 'open'
}

export type IConfig = {
  __typename?: 'Config';
  autoRefreshInterval: Scalars['Int'];
  blockRefresh: Scalars['Int'];
  certDisclaimer: ILangString;
  forceITSR3Client: ForceItsr3Client;
  hasCertification: Scalars['Boolean'];
  hasPreparation: Scalars['Boolean'];
  hideObjectiveId: Scalars['Boolean'];
  instanceName: ILangString;
  interimReportEnabled: Scalars['Boolean'];
  lang: Scalars['String'];
  maxObjectiveLevel: Scalars['Int'];
  minObjectiveLevel: Scalars['Int'];
  newTanGroupTans: Scalars['Int'];
  oidcProctorSignup: OidcProctorSignup;
  supportIFrameUrl?: Maybe<Scalars['String']>;
  tanDisclaimer: ILangString;
  tanDisplayProgress: DisplayProgress;
  /** How many days in future the tan exam can be created (this is +1 to the date in the UI to handle timezone differences */
  tanMaxDays: Scalars['Int'];
  testcenterWelcomeEmail: IEMailConfig;
};

export type ICsvOptions = {
  __typename?: 'CsvOptions';
  disabled: Scalars['Boolean'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  line: Scalars['String'];
  quote: Scalars['String'];
  separator: Scalars['String'];
};

export type IDbQuery = {
  __typename?: 'DbQuery';
  cronExport: Scalars['Boolean'];
  csvOptions: ICsvOptions;
  disabled: Scalars['Boolean'];
  id: Scalars['ID'];
  includeInExamZip: Scalars['Boolean'];
  queryId: Scalars['ID'];
  queryType: QueryTypeEnum;
  sql: Scalars['String'];
  uiLabel: ILangString;
};

export enum DisplayProgress {
  Always = 'Always',
  CandidateComplete = 'CandidateComplete',
  Never = 'Never'
}

export type IEMailConfig = {
  __typename?: 'EMailConfig';
  body: ILangString;
  id: Scalars['ID'];
  subject: ILangString;
};

export type IExam = {
  __typename?: 'Exam';
  candidates: Array<ICandidate>;
  certificate: Scalars['String'];
  date: Scalars['String'];
  id: Scalars['ID'];
  isCurrent: Scalars['Boolean'];
  isStandalone: Scalars['Boolean'];
  key: Scalars['String'];
  metadata: Array<IMetaDataField>;
  modules: Array<IModule>;
  name: Scalars['String'];
  persons: Array<IPerson>;
  status: ExamStatus;
  testcenter: ITestcenter;
};

export enum ExamStatus {
  Done = 'done',
  Open = 'open'
}

export enum ForceItsr3Client {
  Always = 'Always',
  Never = 'Never',
  OnlyCandidate = 'OnlyCandidate'
}

export type IIStatus = {
  status: ServerStatus;
};

export type IItem = {
  __typename?: 'Item';
  id: Scalars['ID'];
  index: Scalars['Int'];
  itemId: Scalars['String'];
  score?: Maybe<IScore>;
};

export type ILangString = {
  __typename?: 'LangString';
  id: Scalars['ID'];
  translations: Array<ILangStringValue>;
  value: Scalars['String'];
  xnone: Scalars['String'];
};

export type ILangStringValue = {
  __typename?: 'LangStringValue';
  id: Scalars['ID'];
  isoCode: Scalars['String'];
  value: Scalars['String'];
};

export type IMetaDataComboField = IMetaDataField & {
  __typename?: 'MetaDataComboField';
  id: Scalars['ID'];
  key: Scalars['ID'];
  label: Scalars['String'];
  options: Array<IMetaDataComboFieldOption>;
  required: Scalars['Boolean'];
  value: Scalars['String'];
};

export type IMetaDataComboFieldOption = {
  __typename?: 'MetaDataComboFieldOption';
  id: Scalars['ID'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type IMetaDataField = {
  id: Scalars['ID'];
  key: Scalars['ID'];
  label: Scalars['String'];
  required: Scalars['Boolean'];
};

export type IMetaDataTextField = IMetaDataField & {
  __typename?: 'MetaDataTextField';
  id: Scalars['ID'];
  key: Scalars['ID'];
  label: Scalars['String'];
  regex: Scalars['String'];
  required: Scalars['Boolean'];
  value: Scalars['String'];
};

export type IMetaDataValueInput = {
  key: Scalars['ID'];
  value: Scalars['String'];
};

export type IModule = {
  __typename?: 'Module';
  canBeResetByCandidate: Scalars['Boolean'];
  canBeResetByProctor: Scalars['Boolean'];
  canBeResetBySysAdmin: Scalars['Boolean'];
  cssClass: Scalars['String'];
  disabled: Scalars['Boolean'];
  hasDemo: Scalars['Boolean'];
  id: Scalars['ID'];
  includeDetailsPdf: Scalars['Boolean'];
  longName?: Maybe<Scalars['String']>;
  maxScore?: Maybe<Scalars['Float']>;
  moduleId: Scalars['String'];
  note: ILangString;
  reset: ModuleReset;
  shortName: Scalars['String'];
  topic?: Maybe<Scalars['String']>;
};

export type IModuleGroup = {
  __typename?: 'ModuleGroup';
  disabled: Scalars['Boolean'];
  id: Scalars['ID'];
  key: Scalars['String'];
  longName: ILangString;
  modules: Array<IModule>;
  shortName: ILangString;
};

export enum ModuleReset {
  ByCandidate = 'by_candidate',
  ByProctor = 'by_proctor',
  BySysadmin = 'by_sysadmin',
  Disabled = 'disabled'
}

export type IMutation = {
  __typename?: 'Mutation';
  closeTanGroup: Scalars['Boolean'];
  deleteTanGroup: Scalars['Boolean'];
  dummy?: Maybe<Scalars['String']>;
  finishExam: Scalars['Boolean'];
  impersonateCandidate: Scalars['String'];
  impersonateProctor: Scalars['String'];
  /** @deprecated Use JOB MANAGER to import sharepoints */
  importSharePoints: Scalars['String'];
  insertExam: IExam;
  launchCandidate: Scalars['String'];
  launchDemo: Scalars['String'];
  launchTan: Scalars['String'];
  launchTanGroupModuleUntracked: Scalars['String'];
  login: Scalars['String'];
  loginCandidate: Scalars['String'];
  logout: Scalars['Boolean'];
  newTanGroup: ITanGroup;
  newTanGroupToken: Scalars['String'];
  newToken: Scalars['ID'];
  newTokens: Array<Scalars['ID']>;
  refreshTanGroup: Scalars['Boolean'];
  reopenExam: IExam;
  resetAttempt: ICandidate;
  resetTanGroupPassword: Scalars['String'];
  sendPasswordToTestcenter: ISendPasswordToTestcenterResult;
  /** @deprecated use xlsx upload instead */
  setName: Scalars['Boolean'];
  /** @deprecated use xlsx upload instead */
  setNames: Scalars['Boolean'];
  setPresent: IPerson;
  setTanGroupNames: Scalars['Boolean'];
  syncExam: Scalars['Boolean'];
  syncExams: Scalars['Boolean'];
  updateConfig: Scalars['Boolean'];
  updateExam: IExam;
  updateProctor: IProctor;
  updateTestcenter: ITestcenter;
  upsertAuth: Scalars['Boolean'];
  upsertDbQuery: Scalars['Boolean'];
  upsertModuleGroup: IModuleGroup;
  upsertProctoredExam: IExam;
  upsertSharePoint: ISharePoint;
  validateTan?: Maybe<ITanInfo>;
};


export type IMutationCloseTanGroupArgs = {
  id: Scalars['ID'];
  password: Scalars['String'];
};


export type IMutationDeleteTanGroupArgs = {
  id: Scalars['ID'];
  password: Scalars['String'];
};


export type IMutationDummyArgs = {
  in?: InputMaybe<Scalars['String']>;
};


export type IMutationFinishExamArgs = {
  examId: Scalars['ID'];
};


export type IMutationImpersonateCandidateArgs = {
  examId: Scalars['ID'];
  reference: Scalars['String'];
};


export type IMutationImpersonateProctorArgs = {
  proctorIdOrKey: Scalars['ID'];
};


export type IMutationInsertExamArgs = {
  examDate: Scalars['String'];
  metadata?: InputMaybe<Array<IMetaDataValueInput>>;
  name?: InputMaybe<Scalars['String']>;
  testcenterId: Scalars['ID'];
  xlsxFile: Scalars['Upload'];
};


export type IMutationLaunchCandidateArgs = {
  candidate: Scalars['ID'];
  userAgentString: Scalars['String'];
};


export type IMutationLaunchDemoArgs = {
  candidate: Scalars['ID'];
  userAgentString: Scalars['String'];
};


export type IMutationLaunchTanArgs = {
  metadata?: InputMaybe<Array<IMetaDataValueInput>>;
  tan: Scalars['ID'];
  userAgentString: Scalars['String'];
};


export type IMutationLaunchTanGroupModuleUntrackedArgs = {
  id: Scalars['ID'];
  userAgentString: Scalars['String'];
};


export type IMutationLoginArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type IMutationLoginCandidateArgs = {
  distinguisher: Scalars['String'];
  examId: Scalars['ID'];
};


export type IMutationNewTanGroupArgs = {
  maxTans: Scalars['Int'];
  metadata?: InputMaybe<Array<IMetaDataValueInput>>;
  module: Scalars['ID'];
  name: Scalars['String'];
  password: Scalars['String'];
  testcenter: Scalars['ID'];
  validTo?: InputMaybe<Scalars['String']>;
};


export type IMutationNewTanGroupTokenArgs = {
  id: Scalars['ID'];
  password: Scalars['String'];
  readonly: Scalars['Boolean'];
};


export type IMutationNewTokensArgs = {
  count: Scalars['Int'];
};


export type IMutationRefreshTanGroupArgs = {
  id: Scalars['ID'];
  includeOpen?: InputMaybe<Scalars['Boolean']>;
};


export type IMutationReopenExamArgs = {
  examId: Scalars['ID'];
};


export type IMutationResetAttemptArgs = {
  candidate: Scalars['ID'];
};


export type IMutationResetTanGroupPasswordArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  newPassword: Scalars['String'];
  tanGroupId: Scalars['ID'];
  username?: InputMaybe<Scalars['String']>;
};


export type IMutationSendPasswordToTestcenterArgs = {
  dryRun: Scalars['Boolean'];
  testcenterId: Scalars['String'];
};


export type IMutationSetNameArgs = {
  name: Scalars['String'];
  tan: Scalars['ID'];
};


export type IMutationSetNamesArgs = {
  names: Array<Scalars['String']>;
  tans: Array<Scalars['ID']>;
};


export type IMutationSetPresentArgs = {
  examId: Scalars['ID'];
  present: Scalars['Boolean'];
  reference: Scalars['String'];
};


export type IMutationSetTanGroupNamesArgs = {
  id: Scalars['ID'];
  names: Array<Scalars['ID']>;
  password: Scalars['String'];
  tans: Array<Scalars['ID']>;
};


export type IMutationSyncExamArgs = {
  examId: Scalars['ID'];
};


export type IMutationUpdateConfigArgs = {
  params: IUpdateConfig;
};


export type IMutationUpdateExamArgs = {
  examId: Scalars['ID'];
  xlsxFile: Scalars['Upload'];
};


export type IMutationUpdateProctorArgs = {
  createIfNotExists?: InputMaybe<Scalars['Boolean']>;
  input: IUpdateProctorInput;
};


export type IMutationUpdateTestcenterArgs = {
  createIfNotExists?: InputMaybe<Scalars['Boolean']>;
  input: IUpdateTestcenterInput;
};


export type IMutationUpsertAuthArgs = {
  input: IUpsertAuthInput;
};


export type IMutationUpsertDbQueryArgs = {
  params: IUpsertDbQuery;
};


export type IMutationUpsertModuleGroupArgs = {
  params: IUpsertModuleGroup;
};


export type IMutationUpsertProctoredExamArgs = {
  examDate: Scalars['String'];
  examKey: Scalars['String'];
  metadata?: InputMaybe<Array<IMetaDataValueInput>>;
  name?: InputMaybe<Scalars['String']>;
  proctorId: Scalars['ID'];
  testcenterId: Scalars['ID'];
  xlsxFileBase64: Scalars['String'];
};


export type IMutationUpsertSharePointArgs = {
  params: IUpsertSharePointInput;
};


export type IMutationValidateTanArgs = {
  tan: Scalars['ID'];
};

export type IObjective = {
  __typename?: 'Objective';
  description: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  score: IScore;
};

export enum OidcProctorSignup {
  FirstnameLastnameMatch = 'FirstnameLastnameMatch',
  Never = 'Never'
}

export type IPerson = {
  __typename?: 'Person';
  allExamsCompleted: Scalars['Boolean'];
  anyExamStarted: Scalars['Boolean'];
  candidates: Array<ICandidate>;
  dateOfBirth?: Maybe<Scalars['LocalDate']>;
  exam: IExam;
  id: Scalars['ID'];
  loggedIn: Scalars['Boolean'];
  minITSClient: Scalars['String'];
  name: Scalars['String'];
  present: Scalars['Boolean'];
  reference: Scalars['String'];
};

export type IProctor = {
  __typename?: 'Proctor';
  disabled: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  proctorId: Scalars['String'];
};

export type IProctorFilterInput = {
  standalone?: InputMaybe<Scalars['Boolean']>;
};

export type IQuery = {
  __typename?: 'Query';
  candidate: ICandidate;
  config: IConfig;
  dbQueries: Array<IDbQuery>;
  dummy?: Maybe<Scalars['String']>;
  exam: IExam;
  examMetaData: Array<IMetaDataField>;
  exams: Array<IExam>;
  examsByKey: Array<IExam>;
  info: Scalars['String'];
  modulegroups: Array<IModuleGroup>;
  modules: Array<IModule>;
  person: IPerson;
  proctor: IProctor;
  proctors: Array<IProctor>;
  sharepoints: Array<ISharePoint>;
  status: IStatus;
  tanGroup: ITanGroup;
  tanGroupMetaData: Array<IMetaDataField>;
  testcenter: ITestcenter;
  testcenters: Array<ITestcenter>;
  whoAmI: IWhoAmI;
};


export type IQueryCandidateArgs = {
  candidate: Scalars['ID'];
};


export type IQueryExamArgs = {
  id: Scalars['ID'];
};


export type IQueryExamsByKeyArgs = {
  ignoreAccessFailure?: InputMaybe<Scalars['Boolean']>;
  ignoreNotFoundFailure?: InputMaybe<Scalars['Boolean']>;
  keys: Array<Scalars['ID']>;
  status?: InputMaybe<ExamStatus>;
};


export type IQueryProctorArgs = {
  id: Scalars['ID'];
};


export type IQueryProctorsArgs = {
  filter?: InputMaybe<IProctorFilterInput>;
};


export type IQueryTanGroupArgs = {
  id: Scalars['ID'];
};


export type IQueryTestcenterArgs = {
  id: Scalars['ID'];
};


export type IQueryTestcentersArgs = {
  filter?: InputMaybe<ITestcenterFilterInput>;
};

export enum QueryTypeEnum {
  Exam = 'exam',
  System = 'system'
}

export type IScore = {
  __typename?: 'Score';
  gained: Scalars['Float'];
  lost: Scalars['Float'];
  mastery?: Maybe<Scalars['Float']>;
  max: Scalars['Float'];
  pending: Scalars['Float'];
  percent: Scalars['Float'];
};

export type ISection = {
  __typename?: 'Section';
  id: Scalars['ID'];
  items: Array<IItem>;
  title: Scalars['String'];
};

export type ISendPasswordToTestcenterResult = {
  __typename?: 'SendPasswordToTestcenterResult';
  email_cc: Array<Scalars['String']>;
  email_to: Array<Scalars['String']>;
};

export enum ServerStatus {
  Maintainance = 'maintainance',
  Ok = 'ok'
}

export type ISharePoint = {
  __typename?: 'SharePoint';
  direction: SharePointDirection;
  disabled: Scalars['Boolean'];
  folder: Scalars['String'];
  id: Scalars['ID'];
  sharePointId: Scalars['String'];
  siteUrl: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export enum SharePointDirection {
  Export = 'export',
  Import = 'import'
}

export type IStatus = IIStatus & {
  __typename?: 'Status';
  status: ServerStatus;
};

export type ISubscription = {
  __typename?: 'Subscription';
  dummy?: Maybe<Scalars['String']>;
};

export type ITan = {
  __typename?: 'Tan';
  grade?: Maybe<Scalars['String']>;
  grade_letter?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata: Array<IMetaDataField>;
  name?: Maybe<Scalars['String']>;
  objectives?: Maybe<Array<IObjective>>;
  passed?: Maybe<Scalars['Boolean']>;
  progress?: Maybe<Scalars['String']>;
  score?: Maybe<IScore>;
  sections?: Maybe<Array<ISection>>;
  startTime?: Maybe<Scalars['String']>;
  status: TanStatus;
  tan: Scalars['String'];
};

export type ITanGroup = {
  __typename?: 'TanGroup';
  hasPassword: Scalars['Boolean'];
  id: Scalars['ID'];
  maxTans: Scalars['Int'];
  metadata: Array<IMetaDataField>;
  module: IModule;
  name: Scalars['String'];
  status: TanGroupStatus;
  tan: ITan;
  tans: Array<ITan>;
  tansummary: ITanGroupTanSummary;
  testcenter: ITestcenter;
  validTo: Scalars['String'];
  validatePassword: Scalars['Boolean'];
  visibleTo: Scalars['String'];
};


export type ITanGroupTanArgs = {
  idOrKey: Scalars['ID'];
  password: Scalars['String'];
};


export type ITanGroupTansArgs = {
  password: Scalars['String'];
};


export type ITanGroupValidatePasswordArgs = {
  password: Scalars['String'];
};

export enum TanGroupStatus {
  Done = 'done',
  Open = 'open'
}

export type ITanGroupTanSummary = {
  __typename?: 'TanGroupTanSummary';
  complete: Scalars['Int'];
  inprogress: Scalars['Int'];
  open: Scalars['Int'];
  total: Scalars['Int'];
};

export type ITanInfo = {
  __typename?: 'TanInfo';
  id: Scalars['ID'];
  metaData: Array<IMetaDataField>;
  module: IModule;
};

export enum TanStatus {
  Completed = 'completed',
  Inprogress = 'inprogress',
  Open = 'open'
}

export type ITestcenter = {
  __typename?: 'Testcenter';
  allowance: Scalars['Int'];
  disabled: Scalars['Boolean'];
  id: Scalars['ID'];
  modules: Array<IModule>;
  name: Scalars['String'];
  standalone: Scalars['Boolean'];
  tanGroups: Array<ITanGroup>;
  tansummary: ITanGroupTanSummary;
  testcenterId: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};


export type ITestcenterTanGroupsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};

export type ITestcenterFilterInput = {
  standalone?: InputMaybe<Scalars['Boolean']>;
};

export type IUpdateConfig = {
  autoRefreshInterval?: InputMaybe<Scalars['Int']>;
  blockRefresh?: InputMaybe<Scalars['Int']>;
  certDisclaimer?: InputMaybe<IUpsertLangString>;
  displayObjectiveId?: InputMaybe<Scalars['Boolean']>;
  forceITSR3Client?: InputMaybe<ForceItsr3Client>;
  hasCertification?: InputMaybe<Scalars['Boolean']>;
  hasPreparation?: InputMaybe<Scalars['Boolean']>;
  instanceName?: InputMaybe<IUpsertLangString>;
  interimReportEnabled?: InputMaybe<Scalars['Boolean']>;
  lang?: InputMaybe<Scalars['String']>;
  maxObjectiveLevel?: InputMaybe<Scalars['Int']>;
  minObjectiveLevel?: InputMaybe<Scalars['Int']>;
  oidcProctorSignup?: InputMaybe<OidcProctorSignup>;
  supportIFrameUrl?: InputMaybe<Scalars['String']>;
  tanDisclaimer?: InputMaybe<IUpsertLangString>;
  tanDisplayProgress?: InputMaybe<DisplayProgress>;
  tanMaxDays?: InputMaybe<Scalars['Int']>;
  testcenterWelcomeEmail?: InputMaybe<IUpsertEMailConfig>;
};

export type IUpdateProctorInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  idOrKey: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  proctorId?: InputMaybe<Scalars['ID']>;
};

export type IUpdateTestcenterInput = {
  allowance?: InputMaybe<Scalars['Int']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  exportPassword?: InputMaybe<Scalars['String']>;
  idOrKey: Scalars['ID'];
  limitModules?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  standalone?: InputMaybe<Scalars['Boolean']>;
  testcenterId?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type IUpsertAuthInput = {
  authId: Scalars['ID'];
  webhook?: InputMaybe<Scalars['String']>;
};

export type IUpsertCsvOptions = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Scalars['String']>;
  line?: InputMaybe<Scalars['String']>;
  quote?: InputMaybe<Scalars['String']>;
  separator?: InputMaybe<Scalars['String']>;
};

export type IUpsertDbQuery = {
  cronExport?: InputMaybe<Scalars['Boolean']>;
  csvOptions?: InputMaybe<IUpsertCsvOptions>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  includeInExamZip?: InputMaybe<Scalars['Boolean']>;
  queryId?: InputMaybe<Scalars['ID']>;
  queryType?: InputMaybe<QueryTypeEnum>;
  sql?: InputMaybe<Scalars['String']>;
  uiLabel?: InputMaybe<IUpsertLangString>;
};

export type IUpsertEMailConfig = {
  body?: InputMaybe<IUpsertLangString>;
  subject?: InputMaybe<IUpsertLangString>;
};

export type IUpsertLangString = {
  addValues?: InputMaybe<Array<IUpsertLangStringValue>>;
  deleteValues?: InputMaybe<Array<Scalars['String']>>;
  setValues?: InputMaybe<Array<IUpsertLangStringValue>>;
  setXnone?: InputMaybe<Scalars['String']>;
};

export type IUpsertLangStringValue = {
  isoCode: Scalars['String'];
  value: Scalars['String'];
};

export type IUpsertModuleGroup = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['ID']>;
  longName?: InputMaybe<IUpsertLangString>;
  shortName?: InputMaybe<IUpsertLangString>;
};

export type IUpsertSharePointInput = {
  direction?: InputMaybe<SharePointDirection>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  folder?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  password?: InputMaybe<Scalars['String']>;
  sharePointId?: InputMaybe<Scalars['String']>;
  siteUrl?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type IWhoAmI = {
  __typename?: 'WhoAmI';
  isAnonymous: Scalars['Boolean'];
  isCandidate: Scalars['Boolean'];
  isProctor: Scalars['Boolean'];
};

export type ILaunchTanMutationVariables = Types.Exact<{
  tan: Types.Scalars['ID'];
  userAgentString: Types.Scalars['String'];
  metadata: Array<Types.IMetaDataValueInput> | Types.IMetaDataValueInput;
}>;


export type ILaunchTanMutation = { __typename?: 'Mutation', launchTan: string };

export const LaunchTanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"launchTan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tan"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAgentString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetaDataValueInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"launchTan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tan"}}},{"kind":"Argument","name":{"kind":"Name","value":"userAgentString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAgentString"}}},{"kind":"Argument","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}}]}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class ILaunchTanGQL extends Apollo.Mutation<ILaunchTanMutation, ILaunchTanMutationVariables> {
    override document = LaunchTanDocument;
    override client = 'itsorganizerapi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }